module.exports = __webpack_public_path__ + "img/subscriptions.7c7d35da.svg";